import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM, ROUTE_ENUM } from 'enums';
import { queryClient } from 'App';
import { useNavigate } from "react-router";

interface ScheduleVerificationDetailsType {
  uuid: string | null;
  date: string;
  start: string;
  end: string;
  comment: string;
  employeeUuid: string;
}

const useScheduleVerification = (
  options?: UseMutationOptions<any, Error, ScheduleVerificationDetailsType>
) => {
  const navigate = useNavigate();
  
  return useMutation({
    ...options,
    mutationKey: ['scheduleVerification'],
    mutationFn: async ({ uuid, date, start, end, comment, employeeUuid }) => {
      return axiosInstance.put(`/orders/verification/${uuid}`, {
        date,
        start,
        end,
        comment,
        employeeUuid,
      }).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie umawiania weryfikacji...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'schedule-verification',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Weryfikacja została umówiona pomyślnie',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'schedule-verification',
      });
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      navigate(ROUTE_ENUM.ORDERS_LIST);
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas umawiania weryfikacji',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'schedule-verification',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useScheduleVerification;
